export default {
  "content": "<title>Wifi</title><path d=\"M332.69 320a115 115 0 00-152.8 0m213.85-61a201.26 201.26 0 00-274.92 0M448 191.52a288 288 0 00-383.44 0\" class=\"ionicon-fill-none\"/><path d=\"M300.67 384L256 433l-44.34-49a56.73 56.73 0 0188.92 0z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};